import { createUseStyles } from "react-jss";
import breakpoints from "assets/breakpoints";
import arrow from "assets/images/arrow.svg";
import search_input_icn from "assets/images/search_input_icn.svg";
export const useStyles = createUseStyles({
  search__form: {
    "& .form__row": {
      "& .fr__items": {
        "& .fr__ibox": {
          border: "0",
          "& > .btn-group": {
            width: "100%",
            "& > button": {
              background: "transparent",
              cursor: "text",
              padding: "0",
              border: "0",
              "&:after": {
                display: "inline-block",
                width: "12px",
                height: "8px",
                content: '""',
                backgroundImage: `url(${arrow})`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                position: "absolute",
                top: "50%",
                right: "0",
                border: "0",
                margin: "0",
                transform: "translateY(-50%)",
              },
              "& .grop__placeholder": {
                fontSize: "14px",
                color: "rgb(var(--dark) / 0.65)",
              },
              "& > .selected__one": {
                "& > .selected__otext": {
                  fontSize: "15px",
                  width: "120px !important",
                  [breakpoints.SCREEN_XL_MIN]: {
                    width: "150px !important",
                  },
                },
                "& > .selected__oicn": {
                  maxWidth: "32px",
                  flex: "0 0 32px",
                  height: "32px",
                  "& > span": {
                    fontSize: "13px",
                  },
                },
                "&.selected__multi": {
                  width: "calc(100% - 18px) !important",
                },
              },
            },
            "& > .dropdown-menu": {
              left: "-20px !important",
              minWidth: "300px",
              maxWidth: "360px",
              padding: "0",
              boxShadow:
                "0 0 0 1px rgb(0 0 0 / 6%), 0 4px 11px rgb(0 0 0 / 8%)",
              border: "0",
              "& .selected__list": {
                gap: "3px",
                maxHeight: "155px",
                overflow: "hidden auto",
                padding: "10px",
                borderBottom: "1px solid rgb(var(--light))",
                "& .selected__items": {
                  padding: "7px 12px",
                  backgroundColor: "rgb(var(--dark) / 0.08) !important",
                  "& > span": {
                    fontSize: "12px",
                  },
                  "& > .btn-close": {
                    width: "10px",
                    height: "10px",
                    backgroundSize: "10px",
                  },
                },
              },
              "& .drop__search": {
                paddingInline: "10px",
                "& > input": {
                  padding: "9px 0 10px 26px",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "top 13px left 2px",
                  backgroundImage: `url(${search_input_icn})`,
                  backgroundColor: "transparent !important",
                  borderColor: "transparent",
                  "&:focus, &:focus-visible": {
                    boxShadow: "none",
                  },
                },
              },
              "& .drop__selectall": {
                borderTop: "1px solid rgb(var(--light))",
                padding: "6px 30px",
                "& > span": {
                  fontSize: "14px",
                },
              },
              "& .drop__bottom": {
                maxHeight: "216px",
                overflow: "hidden auto",
                padding: "10px 10px 0 10px",
                borderTop: "1px solid rgb(var(--light))",
                "& .dropdown-item": {
                  display: "flex",
                  borderRadius: "6px",
                  padding: "6px 10px",
                  alignItems: "center",
                  justifyContent: "space-between",
                  transition: "all 0.3s ease-in-out",
                  whiteSpace: "break-spaces",
                  lineHeight: "1.2",

                  "& > span": {
                    fontSize: "14px",
                    color: "rgb(var(--gray))",
                    fontWeight: "var(--fw-500)",
                  },
                  "& > svg": {
                    opacity: "0",
                  },
                  "&:not(:last-child)": {
                    marginBottom: "1px",
                  },
                  "&:not(.active):hover": {
                    backgroundColor: "rgb(var(--dark) / 0.08)",
                    "& > span": {
                      color: "rgb(var(--dark))",
                    },
                  },
                  "&.active": {
                    backgroundColor: "rgb(var(--success) / 0.10)",
                    "& > span": {
                      color: "rgb(var(--success))",
                    },
                    "& > svg": {
                      opacity: "1",
                    },
                  },
                },
              },
            },
          },
        },
        "&.fr__pathway, &.fr__spathway, &.fr__keyword, &.fr__county, &.fr__orgname":
          {
            flex: "1",
          },
        "&.fr__county, &.fr__orgname": {
          "& .fr__ibox": {
            "& input": {
              backgroundColor: "transparent",
              borderColor: "transparent",
              borderRadius: "0",
              paddingInline: "0",
              "&:focus, &:focus-visible": {
                boxShadow: "none",
              },
            },
          },
        },
        "&.fr__action": {
          flex: "0 0 auto",
        },
      },
    },
    "& .error__msg": {
      fontSize: "14px",
      position: "absolute",
      left: "0",
      right: "0",
      bottom: "-22px",
    },
  },
});
